import {Component, forwardRef, Input} from "@angular/core";
import {AbstractControl, FormControl, NG_VALUE_ACCESSOR} from "@angular/forms";
import {FormControlBaseComponent} from "../form-control-base/form-control-base.component";

@Component({
    selector: "pcg-ng-counter",
    template: require('./counter.component.html'),
    providers: [
        {provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => CounterComponent), multi: true},
    ]
})
export class CounterComponent extends FormControlBaseComponent<number|string> {
    @Input()
    public isLocked: boolean;

    @Input()
    public minValue: number = 0;

    @Input()
    public maxValue: number = 999;

    @Input()
    public step: number = 1;

    @Input()
    public allowDecimal: boolean = false;

    @Input()
    public allowEmpty: boolean = false;

    public formControl: AbstractControl = new FormControl(this.DEFAULT_VALUE);

    public constructor() {
        super(/*DEFAULT_VALUE*/0);
    }

    protected writeNewValue(value: any): void {
        if(this.allowEmpty && value === "") {
            super.writeNewValue("");
        } else {
            const fractionDigits = this.allowDecimal ? 3 : 0;
            value = Number(Number(value).toFixed(fractionDigits)); // keep human precision
            if(this.isValidValue(value)) {
                super.writeNewValue(value);
            }
        }
    }

    public writeValue(value: any): void {
        super.writeValue(value);
        this.formControl.setValue(value);
    }

    private isValidValue(value: number|string): boolean {
        if(this.allowEmpty && value === "") {
            return true;
        }
        return !isNaN(Number(`${value}`))
            && value >= this.minValue
            && value < this.maxValue;
    }

    public increase(): void {
        let value: number;
        if(this.allowEmpty && this.controlValue === "") {
            value = 0;
        } else {
            value = + this.controlValue + this.step;
        }
        this.setValue(value);
    }

    public decrease(): void {
        let value: number|string;
        if(this.allowEmpty && this.controlValue === 0) {
            value = "";
        } else {
            value = + this.controlValue - this.step;
        }
        this.setValue(value);
    }

    public handleInput($event: any): void {
        const value = $event.target.value;
        this.setValue(value);
    }

    public submitCount(): void {
        const value = this.formControl.value;
        this.setValue(value);
    }

    private setValue(value: any): void {
        if (!this.isValidValue(value)) {
            this.formControl.setValue(this.controlValue);
        } else {
            this.writeNewValue(value);
        }
    }
}
